import React, { memo } from 'react'
import { AuthScreen } from './AuthScreen'

/**
 * There is no token-entry fallback any more, so a build without `REACT_APP_WORKOS_CLIENT_ID`
 * cannot sign anyone in. Saying that outright beats mounting a shell whose every request would
 * fail as "Unauthorized".
 */
const MissingWorkosConfigComponent = () => {
  return (
    <AuthScreen
      dataTestId="admin-missing-workos-config"
      title="Sign-in is not configured"
      description="This build has no REACT_APP_WORKOS_CLIENT_ID, so it cannot authenticate. Set it in the app's environment and reload."
    />
  )
}

export const MissingWorkosConfig = memo(MissingWorkosConfigComponent)
